// extracted by mini-css-extract-plugin
module.exports = {"s1ivucee":"s1ivucee"};